'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.bindActions = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _handlers = require('./handlers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bindActions = exports.bindActions = function bindActions() {

	$(_Dom2.default.dropdownTrigger).on('mouseenter', function (event) {
		(0, _handlers.closeSubnav)();
		(0, _handlers.openSubnav)($(this));
	});

	$(_Dom2.default.dropdownTrigger).on('mouseleave', function (event) {
		(0, _handlers.closeSubnav)();
	});

	$(_Dom2.default.drawerTrigger).on('click', function (event) {
		event.preventDefault();
		(0, _handlers.toggleMobileNav)();
		(0, _handlers.mobileNavPadding)();
	});

	$(_Dom2.default.flyoutTrigger).on('click', function (event) {
		event.preventDefault();
		(0, _handlers.openFlyout)($(this));
	});

	$(_Dom2.default.flyoutClose).on('click', function (event) {
		event.preventDefault();
		(0, _handlers.closeFlyout)();
	});

	$(_Dom2.default.searchTrigger).on('click', function (event) {
		event.preventDefault();
		(0, _handlers.toggleSearch)();
	});

	$(window).on('resize', function (event) {
		if ($(window).width() >= 992) {
			(0, _handlers.closeMobileNav)();
		}
	});

	(0, _handlers.mobileNavPadding)();
};